import { useTranslation } from 'react-i18next';

type ZugangZaehlerProps = {
  anzahl: number;
  max: number;
  className?: string;
};

export function ZugangZaehler({ anzahl, max, className }: ZugangZaehlerProps) {
  const { t } = useTranslation();

  const limitErreicht = anzahl >= max;

  return (
    <p
      className={`text-xs ${
        limitErreicht ? 'text-primary-red-400' : 'text-neutrals-700'
      } ${className ?? ''}`}>
      {t('domain.e2nApi.zugaenge.tabelle.anzahl', { anzahl, max })}
    </p>
  );
}
